import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import appConfigReducer from "@/store/slices/appConfigSlice";
import authReducer from "@/store/slices/authSlice";
import inspectionsDataReducer from "@/store/slices/inspectionsSlice";
import masterDataReducer from "@/store/slices/masterDataSlice";
import openedInspectionReducer from "@/store/slices/openInspectionSlice";
import appDataReducer from "@/store/slices/appDataSlice";
import { inspectionsStorage } from "@/store/idbStorage/inspectionsStorage";
// import syncUpdatesReducer from "@/store/slices/syncUpdatesSlice";
import uploadProgressReducer from "@/store/slices/uploadProgressSlice";
import localStorage from "redux-persist/es/storage";
import { OpenedInspectionStorage } from "./idbStorage/openedInspectionStorage";

const appDataPersistConfig = {
    key: "appData",
    storage: sessionStorage,
};

const appConfigPersistConfig = {
    key: "appConfig",
    storage: sessionStorage,
};

const authPersistConfig = {
    key: "auth",
    storage: localStorage,
};

const inspectionsDataPersistConfig = {
    key: "inspectionsData",
    storage: inspectionsStorage,
};

// const savedInspectionsPersistConfig = {
//     key: "savedInspections",
//     storage: savedInspectionsStorage,
// };

const openedInspectionPersistConfig = {
    key: "openedInspection",
    storage: OpenedInspectionStorage,
    whitelist: ["inspection", "isModified"],
};

// const syncUpdatesPersistConfig = {
//     key: "syncUpdates",
//     storage: sessionStorage
// }

const uploadProgressPersistConfig = {
    key: "uploadProgress",
    storage: sessionStorage
}

export const rootReducer = combineReducers({
    appConfig: persistReducer(appConfigPersistConfig, appConfigReducer),
    inspectionsData: persistReducer(inspectionsDataPersistConfig, inspectionsDataReducer),
    auth: persistReducer(authPersistConfig, authReducer),
    masterData: masterDataReducer,
    openedInspection: persistReducer(openedInspectionPersistConfig, openedInspectionReducer),
    appData: persistReducer(appDataPersistConfig, appDataReducer),
    uploadProgress: persistReducer(uploadProgressPersistConfig, uploadProgressReducer),
});

// Define RootState type
export type RootState = ReturnType<typeof rootReducer>;
